import CopyButton from '@/components/CopyButton.tsx';
import {Button, Classes, Dialog, InputGroup} from '@blueprintjs/core';
import {ReactElement} from 'react';

interface Props {
	password: string,
	onClose: () => void,
}

export default function PasswordCopyDialog({password, onClose}: Props): ReactElement {
	return (
		<Dialog title="Provider SFTP Password" isOpen={true} onClose={onClose}>
			<div className={Classes.DIALOG_BODY}>
				<p>
					The password for your new provider is below.
				</p>

				<p>
					<strong>Make sure you copy it now!</strong>
				</p>

				<p>
					You will need to reset the provider's password to see this dialog again. Passwords are not stored in
					clear-text, and cannot be retrieved in the future.
				</p>

				<InputGroup
					value={password}
					rightElement={(
						<CopyButton copyText={password} tooltip="Copy Password" />
					)}
				/>
			</div>

			<div className={Classes.DIALOG_FOOTER}>
				<div className={Classes.DIALOG_FOOTER_ACTIONS}>
					<Button intent="danger" text="Close" onClick={onClose} />
				</div>
			</div>
		</Dialog>
	);
}
